import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import Autocomplete from 'vuejs-auto-complete'

export default {
  name: 'SymplaJobsReport',
  computed,
  data,
  methods,
  components: {
    Autocomplete,
  }
}
